



const baseAppletPermissions = {

}



const collectionPermissions = {

    horizontal: true,
    textOnBottom: true,
    hasAdvanced: true,
    advancedTabs: [{ key: 'view', label: 'View' }, { key: 'edit', label: 'Edit' }, { key: 'remove', label: 'Remove' }, { key: 'manage', label: 'Manage' }],

    permissions: {

        view: {
            key: 'view', type: 'permission', title: '{{lang}}View',
            permissions: {
                records: { key: 'records', type: 'permission', title: '{{lang}}Records', type: 'records', main: true },
                fields: { key: 'fields', type: 'permission', title: '{{lang}}Fields', type: 'fields', default: '*', dependancy: 'records', main: true },
            },
            main: true
        },

        create: { key: 'create', type: 'permission', title: '{{lang}}Create', dependancy: 'view', main: true },

        edit: {
            key: 'edit', type: 'permission', title: '{{lang}}Edit', dependancy: 'view', permissions: {
                records: { key: 'records', type: 'permission', title: '{{lang}}Records', main: true },
                fields: { key: 'fields', type: 'permission', title: '{{lang}}Fields', dependancy: 'records', main: true },
            }, main: true
        },

        remove: {
            key: 'remove', type: 'permission', title: '{{lang}}Remove', permissions: {
                records: { key: 'records', type: 'permission', title: '{{lang}}Records', main: true },
            }, dependancy: 'view', main: true
        },

        manage: {
            key: 'manage', type: 'permission', title: '{{lang}}Manage', permissions: {
                views: {
                    type: 'permission', title: "{{lang}}Dynamic Views", horizontal: true, key: 'views', permissions: {
                        view: { key: 'view', type: 'permission', title: '{{lang}}View', main: true },
                        create: { key: 'create', dependancy: 'view', type: 'permission', title: '{{lang}}Create', main: true },
                        edit: { key: 'edit', dependancy: 'view', type: 'permission', title: '{{lang}}Edit', main: true },
                        remove: { key: 'remove', dependancy: 'view', type: 'permission', title: '{{lang}}Remove', main: true },
                    }
                },

                actions: {
                    type: 'permission', title: "{{lang}}Dynamic actions", horizontal: true, key: 'actions', permissions: {
                        view: { key: 'view', type: 'permission', title: '{{lang}}View', main: true },
                        create: { key: 'create', dependancy: 'view', type: 'permission', title: '{{lang}}Create', main: true },
                        edit: { key: 'edit', dependancy: 'view', type: 'permission', title: '{{lang}}Edit', main: true },
                        remove: { key: 'remove', dependancy: 'view', type: 'permission', title: '{{lang}}Remove', main: true },
                    }
                },

                general: {
                    type: 'permission', title: "{{lang}}General", key: 'general', permissions: {
                        editInfo: { key: 'editInfo', type: 'permission', title: '{{lang}}Edit collection information', main: true },
                        viewLog: { key: 'viewLog', type: 'permission', title: '{{lang}}View activity log', main: true },
                        conditionalFormat: { key: 'conditionalFormat', type: 'permission', title: '{{lang}}Manage conditional formating', main: true },
                    }
                },
            }, main: true
        },

    }
}






const stagePermissions = {

    horizontal: true,
    hasAdvanced: true,
    textOnBottom: true,
    advancedTabs: [{ key: 'view', label: 'View' }, { key: 'edit', label: 'Edit' }, { key: 'remove', label: 'Remove' }, { key: 'manage', label: 'Manage' }],

    permissions: {

        view: {
            key: 'view', type: 'permission', title: '{{lang}}View',
            permissions: {
                records: { key: 'records', type: 'permission', title: '{{lang}}Records', main: true },
                fields: { key: 'fields', type: 'permission', title: '{{lang}}Fields', dependancy: 'records', main: true },
            },
            main: true
        },


        edit: {
            key: 'edit', type: 'permission', title: '{{lang}}Edit', dependancy: 'view', permissions: {
                records: { key: 'records', type: 'permission', title: '{{lang}}Records', main: true },
                fields: { key: 'fields', type: 'permission', title: '{{lang}}Fields', dependancy: 'records', main: true },
            }, main: true
        },

        remove: {
            key: 'remove', type: 'permission', title: '{{lang}}Remove',
            // permissions: {
            //     records: { key: 'records',type:'permission', title: '{{lang}}Records', main: true },
            // }, 
            dependancy: 'view', main: true
        },
    }

}




const pagePermissions = {

    horizontal: true,
    textOnBottom: true,
    hasAdvanced: true,
    advancedTabs: [{ key: 'manage', label: 'Manage' }],

    permissions: {


        view: {
            key: 'view', type: 'permission', title: '{{lang}}View',
            // permissions: {
            //     records: { key: 'records',type:'permission', title: '{{lang}}Records', type: 'records', main: true },
            //     fields: { key: 'fields',type:'permission', title: '{{lang}}Fields', type: 'fields', default: '*', dependancy: 'records', main: true },
            // },
            main: true
        },

        edit: {
            key: 'edit', type: 'permission', title: '{{lang}}Edit', dependancy: 'view',
            // permissions: {
            //     records: { key: 'records',type:'permission', title: '{{lang}}Records', main: true },
            //     fields: { key: 'fields',type:'permission', title: '{{lang}}Fields', dependancy: 'records', main: true },
            // },
            main: true
        },

        remove: {
            key: 'remove', type: 'permission', title: '{{lang}}Remove',
            // permissions: {
            //     records: { key: 'records',type:'permission', title: '{{lang}}Records', main: true },
            // }, 
            dependancy: 'view', main: true
        },
        // general: {
        //    type:'permission', title: "{{lang}}General", key: 'general', permissions: {
        //         participate: { key: 'participate',type:'permission', title: '{{lang}}Participate in conversations', main: true },
        //         initiat: { key: 'initiat',type:'permission', title: '{{lang}}Initiat Conversation',dependancy:'participate', main: true },
        //         createGroup: { key: 'createGroup',type:'permission', title: '{{lang}}Create Group',dependancy:'participate', main: true },
        //         // conditionalFormat: { key: 'conditionalFormat',type:'permission', title: '{{lang}}Manage conditional formating', main: true },
        //     }
        // },

        manage: {
            type: 'permission', title: "{{lang}}Manage", key: 'manage', permissions: {
                editSettings: { key: 'editSettings', type: 'permission', title: '{{lang}}Edit settings', main: true },
                editMenu: { key: 'editMenu', type: 'permission', title: '{{lang}}Edit Menu', main: true },
                publishPage: { key: 'publishPage', type: 'permission', title: '{{lang}}Publish page', main: true },
                editPermissions: { key: 'editPermissions', type: 'permission', title: '{{lang}}Edit permissions', main: true },

                // conditionalFormat: { key: 'conditionalFormat',type:'permission', title: '{{lang}}Manage conditional formating', main: true },
            }
        },


    }
}




const messengerPermissions = {

    permissions: {



        general: {
            type: 'permission', title: "{{lang}}General", key: 'general', permissions: {
                participate: { key: 'participate', type: 'permission', title: '{{lang}}Participate in conversations', main: true },
                initiat: { key: 'initiat', type: 'permission', title: '{{lang}}Initiat Conversation', dependancy: 'participate', main: true },
                createGroup: { key: 'createGroup', type: 'permission', title: '{{lang}}Create Group', dependancy: 'participate', main: true },
                // conditionalFormat: { key: 'conditionalFormat',type:'permission', title: '{{lang}}Manage conditional formating', main: true },
            }
        },

        manage: {
            type: 'permission', title: "{{lang}}Manage", key: 'manage', permissions: {
                manageAdmins: { key: 'manageAdmins', type: 'permission', title: '{{lang}}Manage admins', main: true },
                viewReports: { key: 'viewReports', type: 'permission', title: '{{lang}}View reports', main: true },
                // conditionalFormat: { key: 'conditionalFormat',type:'permission', title: '{{lang}}Manage conditional formating', main: true },
            }
        },


    }
}



const typeToPermission = {
    collection: collectionPermissions,
    stage: stagePermissions,
    messenger: messengerPermissions,
    page: pagePermissions,

}



export { baseAppletPermissions, messengerPermissions, pagePermissions, stagePermissions, typeToPermission, collectionPermissions }